const lanterns = {
    id: 'chiang-mai-lanterns',
    type: 'photoPost',
    countryId: 'seAsia',
    title: 'New Year’s Eve Lanterns in Chiang Mai: Photos',
    month: 'Jan',
    date: '6',
    content: [
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/1.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/2.jpg'
        },
       {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/3.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/4.jpg']
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/5.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/6.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/7.jpg'
        },
       {
            images: ['https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/8.jpg', 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/9.jpg']
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/10.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/11.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/12.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/13.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/14.jpg'
        },
       {
            image: 'https://plivesey.github.io/world-of-wander-images/posts/seAsia/lanternphotos/15.jpg'
        },
]
}


export default lanterns


// WEBPACK FOOTER //
// ./src/Posts/Content/lanterns.js